import { bunja } from 'bunja';
import { atom } from 'jotai';

export const warningAlertBunja = bunja(() => {
  const hasSeenWarningAlertKeysAtom = atom<string[]>([]);
  return { hasSeenWarningAlertKeysAtom };
});
warningAlertBunja.debugLabel = 'warningAlertBunja';
